import React from 'react';
import {ModalRequest} from "../common";

const FinishRegistrationModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {

  return (
    <ModalRequest
      open={open}
      onClose={onClose}
      title='Невозможно создать заявку'
    >
      <p className="text-mainBlack">
        Чтобы отправить заявку, необходимо загрузить pdf-файл или фотографию заполненной и подписанной формы о присоединении в разделе "Настройки"
      </p>
    </ModalRequest>
  )
}

export default FinishRegistrationModal;
